import { Link, navigate } from "gatsby"
import Img from "gatsby-image"
import React from "react"

import { FaLink } from "../../AppReactIcons"
import { Lifestyle_InternalLink, Profile_InternalLink } from "../../utils/urls"
import OnlyWithProfile from "../QueryUserProfile/OnlyWithProfile"
import { DarkAppButton } from "../buttons"
import useStore from "../pageComponents/Utils/Store"
import { iAskSectionCard } from "../types"
import { CardContentWrapper, CardWrapper } from "./base"

const CardLink = ({
  title = "Visit",
  Icon = <FaLink />,
  link = "",
  isUser = false,
}) => {
  if (!link) return <React.Fragment />

  const { turnQuizTrue, turnQplTrue } = useStore()

  if (!isUser) {
    switch (title) {
      case "Explore questions":
        return (
          <div className="flex item-center mt-4">
            <Link onClick={turnQplTrue} to={link} state={{ link: link }}>
              <DarkAppButton title={title} Icon={Icon} />
            </Link>
          </div>
        )
      case "Take self assessment quiz":
        return (
          <div className="flex item-center mt-4">
            <Link onClick={turnQuizTrue} to={link} state={{ link: link }}>
              <DarkAppButton title={title} Icon={Icon} />
            </Link>
          </div>
        )
      case "Manage lifestyle":
        return (
          <div className="flex item-center mt-4">
            <Link to={link} state={{ link: link }}>
              <DarkAppButton title={title} Icon={Icon} />
            </Link>
          </div>
        )
    }
  } else {
    return (
      <OnlyWithProfile
        hideLoader={true}
        noRedirectToProfilePage={true}
        childrenWithProfileData={data => {
          let _LINK = data && data.length ? link : Profile_InternalLink
          if (link === Lifestyle_InternalLink) _LINK = link
          return (
            <div className="flex item-center mt-4">
              <Link to={_LINK}>
                <DarkAppButton title={title} Icon={Icon} />
              </Link>
            </div>
          )
        }}
      />
    )
  }
}

export const AskSectionCard: React.FC<iAskSectionCard> = ({
  title,
  link,
  description,
  image,
  buttonTitle,
  buttonIcon,
  isUser,
}) => {
  const DESCRIPTION_LENGTH = 200

  let Button = () => (
    // @ts-ignore
    <CardLink
      title={buttonTitle}
      Icon={buttonIcon}
      link={link}
      isUser={isUser}
    />
  )

  return (
    <CardWrapper>
      <div
        className="cursor-pointer"
        onClick={() => {
          if (!link) return
          navigate(link)
        }}
      >
        <Img
          fluid={image}
          style={{
            borderTopRightRadius: "27px",
            borderTopLeftRadius: "27px",
            height: "240px",
          }}
        />
      </div>
      <CardContentWrapper>
        <h1 className="text-site-blue-dark text-lg">{title}</h1>
        <p className="text-sm my-2">
          {description.slice(0, DESCRIPTION_LENGTH)}
          {description.length > DESCRIPTION_LENGTH && "..."}
        </p>
        <div className="flex flex-1 items-end">
          <Button />
        </div>
      </CardContentWrapper>
    </CardWrapper>
  )
}
